import { render } from "./DashboardRightSecondBanner.vue?vue&type=template&id=76c566ff&scoped=true"
import script from "./DashboardRightSecondBanner.vue?vue&type=script&lang=js"
export * from "./DashboardRightSecondBanner.vue?vue&type=script&lang=js"

import "./DashboardRightSecondBanner.vue?vue&type=style&index=0&id=76c566ff&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76c566ff"]])

export default __exports__